var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPromote = function SvgPromote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M24.414 16.326s-3.911-3.911-3.911-7.17h5.867L15.94 1.332 5.51 9.155h5.867c0 3.26-3.911 7.17-3.911 7.17m2.686 13.994a5.866 5.866 0 0 0-8.819-2.455m20.515 2.455a5.866 5.866 0 0 1 8.819-2.455m-8.521 2.803a7.903 7.903 0 0 0-12.293 0m-8.52-8.312a3.422 3.422 0 1 0 6.845 0 3.422 3.422 0 0 0-6.845 0m22.49 0a3.422 3.422 0 1 0 6.843 0 3.422 3.422 0 0 0-6.844 0M11.6 21.379a4.4 4.4 0 1 0 8.8 0 4.4 4.4 0 0 0-8.8 0",
    vectorEffect: "non-scaling-stroke"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgPromote;